import { render, staticRenderFns } from "./list-questions.vue?vue&type=template&id=5e8454a0"
import script from "./list-questions.vue?vue&type=script&lang=js"
export * from "./list-questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports